/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_docs_loading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading documentation…`)
};

const zh_hans1_docs_loading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载文档...`)
};

const zh_hant1_docs_loading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入文件…`)
};

const fr_docs_loading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la documentation…`)
};

const de_docs_loading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentation wird geladen…`)
};

const ja_docs_loading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドキュメントを読み込んでいます…`)
};

const ko_docs_loading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문서를 불러오는 중…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const docs_loading = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.docs_loading(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("docs_loading", locale)
	if (locale === "en") return en_docs_loading(inputs)
	if (locale === "zh-Hans") return zh_hans1_docs_loading(inputs)
	if (locale === "zh-Hant") return zh_hant1_docs_loading(inputs)
	if (locale === "fr") return fr_docs_loading(inputs)
	if (locale === "de") return de_docs_loading(inputs)
	if (locale === "ja") return ja_docs_loading(inputs)
	return ko_docs_loading(inputs)
};